export default __webpack_public_path__ + "static/media/apple_store.48d9d1b0.svg";